/* eslint-disable import/prefer-default-export */
export const requiredField = (value, _, { intl }) => {
  if (value === undefined) {
    return intl.formatMessage({
      id: 'Form.Error.Required',
      defaultMessage: 'This field is required.',
    });
  }
};
